// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"419": "0a3de51532eb3821","819": "8dd7c99cb4018dd0",}[chunkId] + ".css"
}